import { render } from "./outsourcing.vue?vue&type=template&id=179aeb8c&scoped=true"
import script from "./outsourcing.vue?vue&type=script&lang=js"
export * from "./outsourcing.vue?vue&type=script&lang=js"

import "./outsourcing.vue?vue&type=style&index=0&id=179aeb8c&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179aeb8c"]])

export default __exports__